<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/market/table">卖场列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <span slot="header">表单</span>
      <el-form ref="form"
               :model="form"
               :rules="formRules"
               size="medium"
               label-width="140px"
               @submit.native.prevent="onSubmit()">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item label="所属客户"
                          prop="customer"
                          clearable>
              <el-input v-model="form.customer"
                        placeholder="请输入所属客户"
                        clearable></el-input>
            </el-form-item>

            <el-form-item label="门店系统"
                          prop="custom">
              <el-input v-model="form.custom"
                        placeholder="请输入门店系统"
                        clearable></el-input>
            </el-form-item>
            <el-form-item label="门店名称"
                          prop="marketname">
              <el-input v-model="form.marketname"
                        placeholder="请输入门店名称"
                        clearable></el-input>
            </el-form-item>
            <el-form-item label="门店类型"
                          prop="markettype">
              <el-select class="width-max"
                         v-model="form.markettype"
                         placeholder="请选择门店类型"
                         clearable>
                <el-option
                  v-for="item in options.markettype"
                  :key="item.value"
                  :label="item.label"
                  :disabled="item.disabled"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="营业面积"
                          prop="area_size">
              <el-select class="width-max"
                         v-model="form.area_size"
                         placeholder="请选择营业面积"
                         clearable>
                <el-option
                  v-for="item in options.areatype"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="日化类占比"
                          prop="daily_percent">
              <el-col :span="inputWith"
                      style="width: 260px">
                <el-input v-model.number="form.daily_percent"
                          clearable>
                  <template slot="append">%</template>
                </el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="食品类占比"
                          prop="food_percent">
              <el-col :span="inputWith"
                      style="width: 260px">
                <el-input v-model.number="form.food_percent"
                          clearable>
                  <template slot="append">%</template>
                </el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="饮品类占比"
                          prop="drink_percent">
              <el-col :span="inputWith"
                      style="width: 260px">
                <el-input v-model.number="form.drink_percent"
                          clearable>
                  <template slot="append">%</template>
                </el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="酒水类占比"
                          prop="wine_percent">
              <el-col :span="inputWith"
                      style="width: 260px">
                <el-input v-model.number="form.wine_percent"
                          clearable>
                  <template slot="append">%</template>
                </el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="乳制类占比"
                          prop="milk_percent">
              <el-col :span="inputWith"
                      style="width: 260px">
                <el-input v-model.number="form.milk_percent"
                          clearable>
                  <template slot="append">%</template>
                </el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="粮油类占比"
                          prop="grain_oil_percent">
              <el-col :span="inputWith"
                      style="width: 260px">
                <el-input v-model.number="form.grain_oil_percent"
                          clearable>
                  <template slot="append">%</template>
                </el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="纸品类占比"
                          prop="paper_percent">
              <el-col :span="inputWith"
                      style="width: 260px">
                <el-input v-model.number="form.paper_percent"
                          clearable>
                  <template slot="append">%</template>
                </el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="调味品类占比"
                          prop="spices_percent">
              <el-col :span="inputWith"
                      style="width: 260px">
                <el-input v-model.number="form.spices_percent"
                          clearable>
                  <template slot="append">%</template>
                </el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="有无冷冻/冷藏柜"
                          prop="freezer">
              <el-select class="width-max"
                         v-model="form.freezer"
                         placeholder="请选择有无冷冻/冷藏柜"
                         clearable>
                <el-option
                  v-for="item in options.freezerStatus"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="状态"
                          prop="status">
              <el-select class="width-max"
                         v-model="form.status"
                         placeholder="请选择门店状态"
                         clearable>
                <el-option
                  v-for="item in options.status"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="查理宝平台使用">
              <el-select class="width-max"
                         v-model="form.isee"
                         placeholder="请选择查理宝平台使用"
                         clearable>
                <el-option
                  v-for="item in options.isee"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="是否连锁"
            >
              <el-select class="width-max"
                         v-model="form.is_chain"
                         placeholder="请选择是否连锁"
                         clearable>
                <el-option
                  v-for="item in options.is_chain"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="信息状态">
              <el-select class="width-max"
                         v-model="form.gatherinfo_status"
                         placeholder="请选择信息状态"
                         clearable>
                <el-option
                  v-for="item in options.gatherinfo_status"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  :disabled="getGatherInfoStatus(item.value) || item.disabled">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="门店规模">
              <el-select class="width-max"
                         v-model="form.market_size"
                         placeholder="请选择门店规模"
                         clearable>
                <el-option
                  v-for="item in options.market_size"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="营业开始时间">
              <el-input v-model="form.opening_hours_start"
                        placeholder="请输入营业开始时间"
                        clearable>
              </el-input>
            </el-form-item>
            <el-form-item label="营业结束时间">
              <el-input v-model="form.opening_hours_end"
                        placeholder="请输入营业结束时间"
                        clearable>
              </el-input>
            </el-form-item>
            <el-form-item label="地址"
                          prop="address">
              <el-input v-model="form.address"
                        placeholder="请输入地址"
                        clearable>
              </el-input>
            </el-form-item>
            <el-form-item label="省份"
                          prop="areaid">
              <cascader-district
                size="small"
                style="width: 200px;"
                v-model="areaid"
                @change="onGetProvinceInfo"
                :changeOnSelect="false"/>
            </el-form-item>
            <el-form-item label="街道">
              <el-input v-model="form.street"
                        placeholder="请输入街道"
                        clearable>
              </el-input>
            </el-form-item>
            <el-form-item label="街道号">
              <el-input v-model="form.street_number"
                        placeholder="请输入街道号"
                        clearable>
              </el-input>
            </el-form-item>
            <el-form-item label="坐标类型"
            >
              <el-select class="width-max"
                         v-model="form.map_type"
                         placeholder="请选择坐标类型"
                         clearable>
                <el-option
                  v-for="item in options.map_type"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <div v-if="form.map_type === 0">
              <el-form-item label="百度经度"
                            prop="longitude">
                <div class="flex-row">
                  <el-input v-model="form.longitude"
                            placeholder="请输入百度经度"
                            clearable>
                  </el-input>
                  <el-tooltip class="item" effect="dark" content="从百度地图获取经纬度" placement="top">
                    <i class="el-icon-location location-icon" @click="getBaiduLocation"></i>
                  </el-tooltip>
                </div>
              </el-form-item>
              <el-form-item label="百度纬度"
                            prop="latitude">
                <el-input v-model="form.latitude"
                          placeholder="请输入百度纬度">
                </el-input>
              </el-form-item>
            </div>
              <el-form-item v-if="form.map_type === 1"
                            label="高德经度"
                            prop="lon_gd" >
                <el-input v-model="form.lon_gd"
                          placeholder="请输入高德经度"
                          clearable>
                </el-input>
              </el-form-item>
              <el-form-item v-if="form.map_type === 1"
                            label="高德纬度"
                            prop="lat_gd">
                <el-input v-model="form.lat_gd"
                          placeholder="请输入高德纬度">
                </el-input>
              </el-form-item>
            </div>
            <el-form-item label="店招"
                          prop="photos">
              <image-upload-view v-model="form.photos"
                                 @remove="onRemoveImage"
                                 :multiple="true"
                                 :http-request="uploadRequest"/>
            </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     native-type="submit">提交
          </el-button>
          <el-button @click="onReload">重置</el-button>
        </el-form-item>
      </el-form>
    </layout-panel>

    <!-- 百度地图弹窗 -->
    <el-dialog 
      title="选择位置"
      :visible.sync="mapDialogVisible"
      v-if="mapDialogVisible"
      width="800px"
      :before-close="handleMapDialogClose">
      <div class="map-container">
        <div class="search-container">
          <el-input
            v-model="mapKeyword"
            placeholder="输入地点搜索"
            @keyup.enter.native="searchLocation">
            <el-button slot="append" @click="searchLocation">搜索</el-button>
          </el-input>
          <div class="map-location-info">
            <span v-if="selectedLocation.lng">经度：{{ selectedLocation.lng }}</span>
            <span v-if="selectedLocation.lat">纬度：{{ selectedLocation.lat }}</span>
          </div>
        </div>
        <baidu-map 
          class="bm-view"
          :center="mapLocation"
          :scroll-wheel-zoom="true"
          :zoom="15"
          >
          <bm-local-search 
            :keyword="mapKeyword"
            :auto-viewport="true"
            :center="mapLocation"
            :panel="false"
            @infohtmlset="onLocationSelect">
          </bm-local-search>
           <bm-marker :position="mapLocation" />
        </baidu-map>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="mapDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmLocation" :disabled="!selectedLocation">确认位置</el-button>
      </div>
    </el-dialog>
    
  </div>
</template>

<script>
import { formRules } from '../market.rules.js'
import CascaderDistrict from '@/views/area/components/CascaderDistrict'
import ImageUploadView from '@core/components/ImageUploadControl'
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
import BmLocalSearch from 'vue-baidu-map/components/search/LocalSearch.vue'
import BmMarker from 'vue-baidu-map/components/overlays/Marker.vue'
export default {
  mixins: [],
  components: {
    ImageUploadView,
    CascaderDistrict,
    BaiduMap,
    BmLocalSearch,
    BmMarker
  },
  data () {
    formRules.markettype.push({validator: this.customMarketTypeValidator, trigger: 'blur'})
    return {
      id: 0,
      formRules,
      inputWith: 12,
      areaid: [],
      gatherinfo_status: null,
      form: {
        customer: null,
        custom: null,
        marketname: null,
        markettype: null,
        isee: null,
        is_chain: null,
        gatherinfo_status: null,
        market_size: null,
        opening_hours_start: null,
        opening_hours_end: null,
        address: null,
        street: null,
        street_number: null,
        map_type: 0,
        longitude: null,
        latitude: null,
        lat_gd: null,
        lon_gd: null,
        provinceid: null,
        cityid: null,
        areaid: null,
        status: null,
        photos: [],
        area_size: null,
        daily_percent: null,
        food_percent: null,
        drink_percent: null,
        wine_percent: null,
        milk_percent: null,
        grain_oil_percent: null,
        paper_percent: null,
        spices_percent: null,
        freezer: null,
      },
      loading: false,
      mapDialogVisible: false,
      mapKeyword: '',
      mapLocation: {
        lng: 116.404,
        lat: 39.915
      },
      selectedLocation: {
        lng: null,
        lat: null
      },
    }
  },
  computed: {
    ...Vuex.mapState({
      options: state => state.market.options,
    }),
  },
  watch: {},
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  created () {
  },
  mounted () {
  },
  methods: {
    onLoad () {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id)
      }
    },
    onReload () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.onLoad()
    },
    setForm (id) {
      request.page('getMarketDetail', {id}).then(({data}) => {
        filter.setLoop(this.form, data)
        this.areaid = [String(this.form.provinceid), String(this.form.cityid), String(this.form.areaid)]
        this.gatherinfo_status = this.form.gatherinfo_status
        // 修改后端传0改为null
        if (this.form.market_size === 0) {
          this.form.market_size = null
        }
        // 0: 百度 1：高德
        this.form.map_type = 0
      })
    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (this.form.opening_hours_start && this.form.opening_hours_end && this.form.market_size) {
            this.$confirm('提示：门店规模、营业开始时间、营业结束时间已填，因此信息收集状态将自动变成信息确认?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }).then(() => {
              this.id ? this.update(this.id, this.form) : this.create(this.form)
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消',
              })
            })
          } else {
            this.id ? this.update(this.id, this.form) : this.create(this.form)
          }
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    create (form) {
      request.common('createMarketData', form).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否继续添加？', '提示', {type: 'success'}).then(() => {
          this.$refs.form.resetFields()
          this.areaid = []
        }, () => {
          this.$router.push({path: '/market/table/'})
        })
      })
    },
    update (id, form) {
      request.common('updateMarketData', {id, ...form}).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否前往批量任务列表页面查看任务？', '提示', {type: 'success'}).then(() => {
          this.$router.push({path: '/market/upload/table'})
        })
      })
    },
    remoteProvinceMethod (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          request.loading('queryCitymap', {type: 0}).then((res) => {
            this.provinces = res.data
          })
        }, 200)
      } else {
        this.provinces = []
      }
    },
    remoteCityMethod (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          request.loading('queryCitymap', {keyword: query, type: 1}).then((res) => {
            this.cities = res.data
          })
        }, 200)
      } else {
        this.cities = []
      }
    },
    remoteAreaMethod (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          request.loading('queryCitymap', {keyword: query, type: 2}).then((res) => {
            this.areaes = res.data
          })
        }, 200)
      } else {
        this.areaes = []
      }
    },
    onRemoveImage (index) {
      this.form.photos.splice(index, 1)
    },
    uploadRequest (formData) {
      request.common('uploadMarketPhoto', formData).then(({data}) => {
        this.form.photos.push(data)
      })
    },
    onGetProvinceInfo (value) {
      if (value.length === 3) {
        this.form.provinceid = value[0]
        this.form.cityid = value[1]
        this.form.areaid = value[2]
      }
    },
    getGatherInfoStatus: function (value) {
      if (value === 1 || value === 2) {
        return false
      }
      if (!this.gatherinfo_status) {
        return true
      } else {
        return !(this.gatherinfo_status === value)
      }
    },
    customMarketTypeValidator (rule, value, callback) {
      for (let item of this.options.markettype) {
        if (item.value === value) {
          if (item.disabled) {
            return callback(new Error('此门店类型已经弃用，请修改为其他门店类型'))
          }
          break
        }
      }
      return callback()
    },
    getBaiduLocation () {
      this.mapKeyword = ''
      // 如果表单中已有经纬度，则设置为地图初始位置
      if (this.form.longitude && this.form.latitude) {
        this.selectedLocation = {
          lng: this.form.longitude,
          lat: this.form.latitude
        }
        this.mapLocation = {
          lng: this.form.longitude,
          lat: this.form.latitude
        }
      }
      this.mapDialogVisible = true
    },
    handleMapDialogClose () {
      this.mapDialogVisible = false
      this.mapKeyword = ''
      this.selectedLocation = {
        lng: null,
        lat: null
      }
    },
    searchLocation () {
      this.mapKeyword = this.mapKeyword.trim()
    },
    onLocationSelect (info) {
      this.selectedLocation = info.point
    },
    confirmLocation () {
      if (this.selectedLocation) {
        this.form.longitude = this.selectedLocation.lng
        this.form.latitude = this.selectedLocation.lat
        this.mapDialogVisible = false
      } else {
        this.$message.warning('请选择一个位置')
      }
    }
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
.flex-row {
  display: flex;
  align-items: center;
}
.location-icon {
  margin-left: 5px;
  cursor: pointer;
  color: #409EFF;
  font-size: 20px;
}
.map-location-info {
  margin-left: 5px;
  margin-top: 5px;
  font-size: 14px;
  color: #666;
}
.map-container {
  .search-container {
    margin-bottom: 10px;
  }
  
  .bm-view {
    width: 100%;
    height: 400px;
  }
}

// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/market/pages/MarketForm.vue